// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bPrincipal[data-v-eb7fcb00]{float:right}.bPrincipal[data-v-eb7fcb00],.dBtn[data-v-eb7fcb00]{margin-bottom:15px}.dLast[data-v-eb7fcb00]{margin-top:25px}", ""]);
// Exports
module.exports = exports;
